<template>
  <div>
    <el-menu :default-active="activeIndex" class="d-flex" mode="horizontal" :router="true" type="flex">
      <el-menu-item class="mr-auto">SunBlog</el-menu-item>
      <el-menu-item index="/home">{{"首页"}}</el-menu-item>
      <el-menu-item index="/archive" @click="handleArchiveClick">{{"归档"}}</el-menu-item>
      <el-menu-item index="/about">{{"关于"}}</el-menu-item>
      <el-menu-item index="/apply">{{"友链互换"}}</el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "f-header",
  computed: {
    activeIndex() {
      return this.$store.state.activeIndex;
    }
  },
  methods: {
    handleArchiveClick() {
      this.$store.commit("queryCategoryInfoList");
      this.$store.commit("queryArticleList", {
        categoryId: 0,
        page: 1,
        searchParam: "",
      });
    },
  },
};
</script>

<style scoped>
</style>